export default "__VITE_ASSET__j7In0EmW__"